import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FaArrowLeft, FaUpload, FaTrash } from "react-icons/fa";
import { updateKyc, VendorKycDataGet } from "../../redux/services/kycService/kyc.Services";
import { successToast, errorToast } from "../../Utils/toast";

function UploadKycPage() {
    const navigate = useNavigate();
    const { id } = useParams();

    const location = useLocation();

    const initialVendorId = location.state?.vendorId || id || "";
    const initialUserName = location.state?.name || "";
    const initialMobile = location.state?.mobile || "";
    const initialEmail = location.state?.email || "";

    const [formData, setFormData] = useState({
        vendor_id: initialVendorId,
        name: initialUserName,
        mobile: initialMobile,
        email: initialEmail,
        address: "",
        website_url: "",
        aadhaar_number: "",
        pan_number: "",
        gst_number: "",
    });

    const [files, setFiles] = useState({
        aadhaar_front: null,
        aadhaar_back: null,
        pan_card_image: null,
        gst_certificate: null,
        business_registration: null,
    });

    const [previews, setPreviews] = useState({});
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        const fetchKycData = async () => {
            if (!initialVendorId) return;
            try {

                const payload = {
                    vendor_id: id
                }
                const res = await VendorKycDataGet(payload);
                const kyc = res?.data?.kyc;

                if (kyc) {
                    setFormData((prev) => ({
                        ...prev,
                        vendor_id: initialVendorId,
                        name: kyc.name || prev.name,
                        mobile: kyc.mobile || prev.mobile,
                        address: kyc.address || prev.address,
                        email: kyc.email || prev.email,
                        website_url: kyc.website_url || prev.website_url,
                        aadhaar_number: kyc.aadhaar_number || prev.aadhaar_number,
                        pan_number: kyc.pan_number || prev.pan_number,
                        gst_number: kyc.gst_number || prev.gst_number,
                    }));
                    const baseUrl = process.env.REACT_APP_IMAGE_URL;
                    setPreviews((prev) => ({
                        ...prev,
                        aadhaar_front: kyc.aadhaar_front_url ? baseUrl + kyc.aadhaar_front_url : null,
                        aadhaar_back: kyc.aadhaar_back_url ? baseUrl + kyc.aadhaar_back_url : null,
                        pan_card_image: kyc.pan_card_image_url ? baseUrl + kyc.pan_card_image_url : null,
                        gst_certificate: kyc.gst_certificate_url ? baseUrl + kyc.gst_certificate_url : null,
                    }));
                }
            } catch (err) {
                console.error("KYC data fetch error:", err);
            }
        };
        fetchKycData();
    }, [initialVendorId]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;
        if (name === "mobile") {
            formattedValue = value.replace(/\D/g, "").slice(0, 10);
        }
        if (name === "aadhaar_number") {
            formattedValue = value.replace(/\D/g, "").slice(0, 12);
        }

        if (name === "pan_number") {
            formattedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
        }
        if (name === "gst_number") {
            formattedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15);
        }
        setFormData((prev) => ({ ...prev, [name]: formattedValue }));

        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };
    const handleFileChange = (key, file) => {
        if (!file) return;
        if (file.size > 2 * 1024 * 1024) {
            return setErrors((prev) => ({ ...prev, [key]: "File size must be under 2MB" }));
        }
        setFiles((prev) => ({ ...prev, [key]: file }));
        setPreviews((prev) => ({ ...prev, [key]: URL.createObjectURL(file) }));
        if (errors[key]) {
            setErrors((prev) => ({ ...prev, [key]: "" }));
        }
    };
    const removeFile = (key) => {
        setFiles((prev) => ({ ...prev, [key]: null }));
        setPreviews((prev) => ({ ...prev, [key]: null }));
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.name) newErrors.name = "Vendor name is required";
        if (!formData.mobile) {
            newErrors.mobile = "Mobile is required";
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            newErrors.mobile = "Mobile must be exactly 10 digits";
        }
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (!formData.address) newErrors.address = "Address is required";
        if (!formData.aadhaar_number) {
            newErrors.aadhaar_number = "Aadhaar Number is required";
        } else if (!/^\d{12}$/.test(formData.aadhaar_number)) {
            newErrors.aadhaar_number = "Aadhaar must be exactly 12 digits";
        }

        if (!formData.pan_number) {
            newErrors.pan_number = "PAN Number is required";
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan_number)) {
            newErrors.pan_number = "Invalid PAN format (e.g., ABCDE1234F)";
        }
        if (!files.aadhaar_front && !previews.aadhaar_front)
            newErrors.aadhaar_front = "Aadhaar front is required";
        if (!files.aadhaar_back && !previews.aadhaar_back)
            newErrors.aadhaar_back = "Aadhaar back is required";
        if (!files.pan_card_image && !previews.pan_card_image)
            newErrors.pan_card_image = "PAN card is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        try {
            setLoading(true);
            const apiData = new FormData();
            apiData.append("vendor_id", formData.vendor_id);
            apiData.append("module_id[0]", "1");
            apiData.append("email", formData.email);
            apiData.append("website_url", formData.website_url);
            apiData.append("aadhaar_number", formData.aadhaar_number);
            apiData.append("pan_number", formData.pan_number);
            apiData.append("gst_number", formData.gst_number);
            apiData.append("name", formData.name);
            apiData.append("mobile", formData.mobile);
            apiData.append("address", formData.address);
            Object.entries(files).forEach(([key, file]) => {
                if (file) {
                    apiData.append(key, file);
                }
            });
            const res = await updateKyc(apiData);
            if (res?.success !== false) {
                successToast(res?.message || "KYC updated successfully");
                navigate("/user-list");
            } else {
                errorToast(res?.message || "Upload failed");
            }
        } catch (err) {
            errorToast(err?.response?.data?.message || err?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };
    const renderFileInput = (key, label) => (
        <div className="col-md-6 mb-3">
            <label className="form-label">
                {label}  <span className="text-danger">*</span>
            </label>
            <div className="d-flex align-items-start gap-3">
                <div className="flex-grow-1">
                    <input
                        type="file"
                        className={`form-control ${errors[key] ? "is-invalid" : ""}`}
                        accept="image/*,application/pdf"
                        onChange={(e) => handleFileChange(key, e.target.files[0])}
                    />
                    {errors[key] && <div className="invalid-feedback d-block">{errors[key]}</div>}
                </div>
                {previews[key] && (
                    <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={() => removeFile(key)}
                        title="Remove"
                    >
                        <FaTrash />
                    </button>
                )}
            </div>
            {previews[key] && (
                <div className="mt-2">
                    <img
                        src={previews[key]}
                        alt={label}
                        style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 8, border: "1px solid #ddd" }}
                    />
                </div>
            )}
        </div>
    );

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
                <div className="title_member">
                    <h4>Update Vendor KYC</h4>
                </div>
                <button className="add-btn" onClick={() => navigate(-1)}>
                    <FaArrowLeft />
                </button>
            </div>

            <div className="main_page">
                <div className="st-wrapper-card p-4">
                    <form onSubmit={handleSubmit} noValidate>

                        <div className="row g-3 mb-4">

                            <div className="col-md-6">
                                <label className="form-label">Name<span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Enter Name"
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Mobile <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleInputChange}
                                    placeholder="Enter Mobile number"
                                    maxLength={10}
                                />
                                {errors.mobile && <div className="invalid-feedback">{errors.mobile}</div>}
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Email <span className="text-danger">*</span></label>
                                <input
                                    type="email"
                                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Enter Email"
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Address <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.address ? "is-invalid" : ""}`}
                                    name="address"
                                    value={formData.address}
                                    onChange={handleInputChange}
                                    placeholder="Enter Address"
                                />
                                {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Aadhaar Number <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.aadhaar_number ? "is-invalid" : ""}`}
                                    name="aadhaar_number"
                                    value={formData.aadhaar_number}
                                    onChange={handleInputChange}
                                    placeholder="123456789012"
                                    maxLength={12}
                                />
                                {errors.aadhaar_number && <div className="invalid-feedback">{errors.aadhaar_number}</div>}
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">PAN Number <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.pan_number ? "is-invalid" : ""}`}
                                    name="pan_number"
                                    value={formData.pan_number}
                                    onChange={handleInputChange}
                                    placeholder="ABCDE1234F"
                                    maxLength={10}
                                    style={{ textTransform: "uppercase" }}
                                />
                                {errors.pan_number && <div className="invalid-feedback">{errors.pan_number}</div>}
                            </div>

                        </div>

                        <div className="row g-3 mb-4">
                            {renderFileInput("aadhaar_front", "Aadhaar Card Front", true)}
                            {renderFileInput("aadhaar_back", "Aadhaar Card Back", true)}
                            {renderFileInput("pan_card_image", "PAN Card", true)}
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button type="button" className="btn btn-danger" onClick={() => navigate(-1)}>
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                <FaUpload className="me-2" />
                                {loading ? "Uploading..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default UploadKycPage;